'use client'

import { useMemo } from 'react'
import { Text } from '@vinted/web-ui'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useCatalogContext } from '@marketplace-web/catalog/catalog-page-data'

type Props = {
  truncate?: boolean
}

const Title = ({ truncate = false }: Props) => {
  const translate = useTranslate()
  const {
    state: { filters, data, catalogBrand, general },
  } = useCatalogContext()
  const { catalogIds, disableSearchSaving } = filters
  const { brand } = catalogBrand

  const titlesJoinElement = ' '
  const catalogTitle = general.title

  const catalogTitleFromResponseEnabled = useFeatureSwitch('web_catalog_title_from_response')

  const catalogs = useMemo(() => {
    return catalogIds
      .map(catalogId => data.catalogs.find(catalog => catalog.id === catalogId))
      .filter(Boolean)
  }, [catalogIds, data.catalogs])

  function getPopularCatalogTitle() {
    const popularCatalogTitle = translate('catalog.popular_items.title')

    if (!brand) return popularCatalogTitle

    return [popularCatalogTitle, brand.title].join(titlesJoinElement)
  }

  function getTitle() {
    const title: Array<string> = []

    if (catalogs.length === 1) {
      title.push(catalogs[0]!.title)
    }

    if (brand) {
      title.push(brand.title)
    }

    if (title.length) return title.join(titlesJoinElement)

    return translate('catalog.items')
  }

  function getText() {
    if (catalogTitleFromResponseEnabled && disableSearchSaving) {
      return catalogTitle || getTitle()
    }

    return disableSearchSaving ? getPopularCatalogTitle() : getTitle()
  }

  return <Text type="heading" text={getText()} truncate={truncate} as="h1" />
}

export default Title
